// extracted by mini-css-extract-plugin
export default {"header":"hawk-tabletop-header-header","header-text":"hawk-tabletop-header-header-text","headerText":"hawk-tabletop-header-header-text"};